import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import DiamondMark from "@/components/DiamondMark";
import AwaitingApproval from "@/components/AwaitingApproval";

export default function ProtectedRoute({ children }) {
  const { user, pending, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen bg-bd-black flex items-center justify-center">
        <DiamondMark size={40} className="animate-pulse" />
      </div>
    );
  }
  if (pending) return <AwaitingApproval />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
